import { onBeforeUnmount, ref, type Ref } from 'vue'

// Reactive `window.matchMedia`. Returns false on the server and in environments
// without matchMedia (jsdom without a stub), so callers can default to the phone
// tier and hydrate up.
export function useMediaQuery(query: string): Ref<boolean> {
    const matches = ref(false)

    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return matches

    const mql = window.matchMedia(query)
    const update = (event: { matches: boolean }) => {
        matches.value = event.matches
    }

    update(mql)
    mql.addEventListener('change', update)
    onBeforeUnmount(() => mql.removeEventListener('change', update))

    return matches
}
